angular.module("vgresiduos").factory("jobPositionService", [
	"$http",
	function ($http) {
		"use strict";

		function _getJobPositions() {
			const req = {
				method: "get",
				url: Vgr.constants.coreHostUrl + "v1/job-positions"
			};
			return $http(req);
		}

		function _getJobPositionAreas() {
			const req = {
				method: "get",
				url: Vgr.constants.coreHostUrl + "v1/job-position-areas"
			};
			return $http(req);
		}

		return {
			getJobPositions: _getJobPositions,
			getJobPositionAreas: _getJobPositionAreas
		};
	}
]);
